export const FETCHING_START = "FETCHING_START"
export const FETCHING_SUCCESS_CUSTOMER = "FETCHING_SUCCESS_CUSTOMER"
export const FETCHING_SUCCESS_CUSTOMER_PAYMENTS = "FETCHING_SUCCESS_CUSTOMER_PAYMENTS"
export const FETCHING_SUCCESS_ARES = "FETCHING_SUCCESS_ARES"
export const FETCHING_SUCCESS_COLLECTOR = "FETCHING_SUCCESS_COLLECTOR"
export const FETCHING_SUCCESS_COLLECTOR_PAYMENTS = "FETCHING_SUCCESS_COLLECTOR_PAYMENTS"
export const FETCHING_SUCCESS_USER = "FETCHING_SUCCESS_USER"
export const FETCHING_SUCCESS_ADMIN = "FETCHING_SUCCESS_ADMIN"
export const FETCHING_OF = "FETCHING_OF"
export const FETCHING_REFETCH = "FETCHING_REFETCH"
export const FETCHING_ERROR = "FETCHING_ERROR"